export default "__VITE_ASSET__7d6753ba__"